import AccountModel from '@/models/services/account/AccountModel';
import appStore     from '@/stores/appStore';
import useDidMount  from '@widesk-core/hooks/useDidMount';
import { reaction } from 'mobx';
import { useState } from 'react';

const useAccount = () => {
	const [account, setAccount] = useState<AccountModel | null>(appStore.account);

	const selectAccount = async (id: id | null) => {
		id ? await appStore.fetchAccount(id) : appStore.resetAccount();
	};

	useDidMount(() => reaction(() => appStore.account, v => setAccount(v)));

	return {
		account,
		selectAccount,
		accountUrn: appStore.accountUrn,
	};
};

export default useAccount;